import { render, staticRenderFns } from "./DeParaBdgdImportadaServidorDataTable.vue?vue&type=template&id=838b0ac2&scoped=true&"
import script from "./DeParaBdgdImportadaServidorDataTable.vue?vue&type=script&lang=js&"
export * from "./DeParaBdgdImportadaServidorDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DeParaBdgdImportadaServidorDataTable.vue?vue&type=style&index=0&id=838b0ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838b0ac2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCol,VDataTable,VIcon,VRow,VTextField})
